// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".login[data-v-72e7cb4c]{overflow:scroll;width:450px;border-radius:10px}@media screen and (max-width:600px){.login[data-v-72e7cb4c]{overflow:scroll;width:93%}}", ""]);
// Exports
module.exports = exports;
